import createCache from '@emotion/cache'
import { CacheProvider, Global } from '@emotion/core'
import { ThemeProvider } from 'emotion-theming'
import PropTypes from 'prop-types'
import React from 'react'
import {
  globalStyles,
  Theme,
  themeHighContrast,
  themeNormal,
} from '../../constants/theme'
import px2rem from '../../lib/px2rem'
import { getIsHighContrast } from '../../lib/storage'

export default class ThemeManager extends React.Component<
  { overrideStyles?: any },
  { theme: Theme }
> {
  static childContextTypes = {
    setTheme: PropTypes.func,
  }

  constructor(props) {
    super(props)
    this.state = {
      theme: this.getTheme(),
    }
  }

  getChildContext() {
    return {
      setTheme: this.setTheme,
    }
  }

  getTheme = (isHighContrast = getIsHighContrast()) =>
    isHighContrast ? themeHighContrast() : themeNormal()

  setTheme = (isHighContrast = getIsHighContrast()) => {
    this.setState({
      theme: this.getTheme(isHighContrast),
    })
  }

  render() {
    const { overrideStyles } = this.props
    const { theme } = this.state
    const styles = globalStyles(theme)
    if (overrideStyles) {
      Object.keys(overrideStyles).forEach(key => {
        const existingStyle = styles[key]
        styles[key] = {
          ...existingStyle,
          ...overrideStyles[key],
        }
      })
    }
    return (
      <CacheProvider value={createCache({ stylisPlugins: px2rem })}>
        <ThemeProvider theme={theme}>
          <Global styles={styles} />
          {this.props.children}
        </ThemeProvider>
      </CacheProvider>
    )
  }
}
